import Moment from "moment";

export default function formatter(type, data) {
  // Return '-' immediately for null, undefined, or empty string
  if (data === null || data === undefined || data === "") {
    return "-";
  }

  try {
    let result = data;

    if (type === "SQLDate") {
      const date = Moment(new Date(data));
      result = date.isValid() ? date.format("YYYY-MM-DD") : "-";
    } else if (type === "number") {
      const num = Number(data);
      result = !isNaN(num)
        ? new Intl.NumberFormat("id-ID", {
            minimumFractionDigits: 0,
          }).format(num)
        : "-";
    } else if (type === "currency") {
      const num = Number(data);
      result = !isNaN(num)
        ? new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(num)
        : "-";
    } else if (type === "thousands") {
      const num = Number(data);
      result = !isNaN(num)
        ? new Intl.NumberFormat("id-ID", {
            minimumFractionDigits: 0,
          }).format(num)
        : "-";
    } else if (type === "dateOnly") {
      const date = Date.parse(data);
      result = !isNaN(date)
        ? new Intl.DateTimeFormat("id-ID", {
            day: "numeric",
            year: "numeric",
            month: "long",
          }).format(date)
        : "-";
    } else if (type === "longDate") {
      const date = Date.parse(data);
      result = !isNaN(date)
        ? new Intl.DateTimeFormat("id-ID", {
            weekday: "long",
            day: "numeric",
            year: "numeric",
            month: "long",
          }).format(date)
        : "-";
    } else if (type === "completeDate") {
      const date = Date.parse(data);
      result = !isNaN(date)
        ? new Intl.DateTimeFormat("id-ID", {
            dateStyle: "medium",
            timeStyle: "medium",
          }).format(date)
        : "-";
    } else if (type === "timestampDate") {
      const date = Moment(new Date(data));
      result = date.isValid() ? date.format("YYYY-MM-DD HH:mm:ss") : "-";
    }

    return result === data ? "-" : result; // Return '-' if no formatting was applied
  } catch (error) {
    console.error("Formatter error:", error);
    return "-";
  }
}
